import axios from 'axios';
import { EVENTS, trackEvent } from '@/plugins/gainsight';
import {
  BudgetGroupAthlete,
  type ApiStoreTeamBudgetGroupAthleteRequest,
  type ApiStoreTeamBudgetGroupAthleteResponse,
  type StoreTeamBudgetGroupAthleteResponse,
} from '@/types/v2/athletes';

export async function createAthlete(
  teamTwrn: string,
  budgetGroupTwrn: string,
  payload: ApiStoreTeamBudgetGroupAthleteRequest,
): Promise<StoreTeamBudgetGroupAthleteResponse> {
  const path = `v1/teams/${teamTwrn}/budget-groups/${budgetGroupTwrn}/athletes`;

  const { data, status } = await axios.post<ApiStoreTeamBudgetGroupAthleteResponse>(path, payload);

  if (status === 201) {
    trackEvent(EVENTS.ATHLETE_CREATED, { teamTwrn });
  }

  return {
    teamTwrn: data.team_twrn,
    budgetGroupTwrn: data.budget_group_twrn,
    budgetTwrns: data.budget_twrns,
    athlete: BudgetGroupAthlete.fromApi(data.athlete),
  };
}
